import { Component, OnInit } from '@angular/core';
import { FincasApiService } from '../../../../../service/api/fincas-api.service';
import { DashboardService } from '../../../../../service/events/dashboard.service';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseForm } from '../../../../base-form';
import {
    build,
    pool,
} from '@fitogest/reactive-form-builder/utils';
import { environment } from '../../../../../../environments/environment';
import { ClientesApiService } from 'src/app/service/api/clientes-api.service';

import { HttpStatusCode } from '@angular/common/http';

import { CRMApiService } from 'src/app/service/api/crm.service';

import { CrmModel } from 'src/app/models/crm/crm.model';
import { CRMFormDefinition } from './fields/formfields';
import { ReactiveFormRequestCoordinator } from '@fitogest/reactive-form-builder/form-request';
import { ReactiveFormStableValueChange } from '@fitogest/reactive-form-builder/interfaces';

@Component({
    selector: 'app-crm-form',
    standalone: false,
    templateUrl: './crm-form.component.html',
    styleUrls: ['./crm-form.component.scss'],
})
export class CrmFormComponent extends BaseForm<CrmModel> implements OnInit {
    /** Reactive form definition bound to the template */
    public form!: CRMFormDefinition;

    /** Form request engine (phase-based hooks) */
    public readonly formRequest = new ReactiveFormRequestCoordinator<CrmModel>;

    /** Expose enums/tokens to the template */
    public readonly HTTP = HttpStatusCode;


    public serverUrl = environment.serverUrl;

    public reactiveFormRecordId = '';


    visible = false;

    constructor(
        public override route: ActivatedRoute,
        public override router: Router,
        public fincasApi: FincasApiService,
        private readonly clientesApi: ClientesApiService,
        public override dashboard: DashboardService,
        public readonly crmApiService: CRMApiService,
    ) {
        super(
            route,
            router,
            dashboard,
            crmApiService.CRM.PUT,
            crmApiService.CRM.POST,
            'crm',
            'Editar Tarea comercial',
            'Crear Tarea comercial'
        );
        this.formRequest = new ReactiveFormRequestCoordinator<CrmModel>;
    }

    ngOnInit(): void {
        this.resetExternalDropdowns();
        const type = this.getType();
        const baseModel = this.getModel() as unknown as Record<string, string>;

        this.reactiveFormRecordId = this.resolveReactiveFormRecordId(baseModel);
        this.initializeHostModel(baseModel as unknown as CrmModel);
        this.form = new CRMFormDefinition(type, baseModel, null);
        this.softInit(this.getType());
        this.initFormData();
    }

    public stableValueChanges(event: ReactiveFormStableValueChange<CrmModel>): void {
        const stableValue = this.captureStableValueChange(event.value as CrmModel);

        this.form.model = stableValue as typeof this.form.model;
        this.form.tag = event.changedField;
        this.syncModelFromForm();
    }

    private syncModelFromForm(): void {
        const normalizedModel = { ...(this.form.model as Record<string, unknown>) } as unknown as CrmModel;

        this.form.model = normalizedModel as typeof this.form.model;
        this.updateHostModel(normalizedModel);
    }

    private initFormData(): Promise<boolean> {
        const builds = [
            build(this.clientesApi.clientesGET, this.form.clientes,
                (it: { nombre: string; telefono: string }) => it.nombre + ' (Teléfono: ' + (it.telefono || '') + ')',
                false, false),
        ];

        // Common notifier: run in a microtask to mirror async pool completion timing
            const notify = (): void => { queueMicrotask(() => {
                this.finalizeExternalDropdowns();
                this.refreshReactiveDropdownMappings();
            }); };

            // No tasks -> fire trigger efficiently and resolve
            if (builds.length === 0) {
              notify();
              return Promise.resolve(true);
            }

            // Tasks exist -> fire trigger after pool resolves
            return pool(builds, notify);
    }

    private refreshReactiveDropdownMappings(): void {
        this.formBuilderRef?.refreshExternalDropdownMappings();
    }
}